<template>
  <div class="container">
    <!-- start carousel -->
    <div id="carouselExampleIndicators" class="carousel slide">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
          aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
          aria-label="Slide 2"></button>
      </div>

      <div class="carousel-inner">
        <div class="carousel-item active">
        </div>
        <div class="carousel-item">
        </div>
      </div>
    </div>
    <!-- end carousel -->

    <div v-if="list.length > 0" class="container mb-5">
      <div class="row justify-content-center">
        <div class="card card-symbol mt-4 p-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <p class="title">ชื่อย่อหุ้น</p>
                <h3 class="fw-bold">
                  {{ list[0].symbol }} <span style="color: #E87D2E;">{{ formatLastTwoDecimal(list[0].last) }}</span> THB
                </h3>
                <div class="text-update text-secondary mt-3" v-if="list[0].time">Updated: {{ formatDate(list[0].time) }}
                </div>
              </div>
              <div class="col-lg-2">
                <p class="title underline">เปลี่ยนแปลง (%)</p>
                <p class="text-title" v-if="list[0].time" :class="changeClass(list[0].last, list[0].prior)">
                  {{ calculateChange(list[0].last, list[0].prior) }} ({{ calculatePercentageChange(list[0].last,
                    list[0].prior) }}%)
                </p>
              </div>
              <div class="col-lg-2">
                <p class="title underline">ปริมาณซื้อขาย (หุ้น)</p>
                <p class="text-title" v-if="list[0].totalVolume">{{ formatNumber(list[0].totalVolume) }}</p>
              </div>
              <div class="col-lg-2">
                <p class="title underline">ช่วงราคาระหว่างวัน</p>
                <p class="text-title" v-if="list[0].time">{{ formatLastTwoDecimal(list[0].low) }} - {{ formatLastTwoDecimal(list[0].high) }}</p>
              </div>
              <div class="col-lg-3">
                <div class="d-grid gap-2 col-lg-8">
                  <button class="btn btn-primary btn-primary" type="button" @click="goToStockPriceInfo">
                    ราคาหลักทรัพย์
                  </button>
                  <button class="btn btn-outline-primary custom-button-outlin" type="button" @click="redirectToFactSheet">
                    Fact Sheet
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 100px;">
      <div class="spinner-grow custom-spinner" role="status"></div>
    </div>

    <!-- start text  -->
    <div class="container text-center mt-3 mb-5">
      <div class="mb-3">
        <h4>นักลงทุนสัมพันธ์</h4>
      </div>
      <div class="mb-3">
        <h3><b>ยินดีต้อนรับสู่ หน้าหลักนักลงทุนสัมพันธ์</b></h3>
        <div class="row">
          <div class="col">
            <div class="custom-line"></div>
          </div>
        </div>
      </div>
      <div class="fs-6 fs-md-5 fs-lg-4">
        บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน) ก่อตั้งขึ้นใน พ.ศ. 2552 เพื่อประกอบธุรกิจพัฒนาอสังหาริมทรัพย์
      </div>
      <div class="fs-6 fs-md-5 fs-lg-4">
        โดยทางบริษัทฯ มุ่งพัฒนาอสังหาริมทรัพย์ประเภทคอนโดมิเนียมบนพื้นที่ที่ให้ความสะดวกในการเดินทางอันได้แก่ทำเล
      </div>
      <div class="fs-6 fs-md-5 fs-lg-4">
        ตามแนวสถานีขนส่งมวลชนระบบรางในเขตกรุงเทพมหานครและ ปริมณฑล และทำเลใกล้ทางด่วน เป็นต้น
      </div>
    </div>
    <!-- end text -->
    <div class="container justify-content-center text-center mb-5">
      <p class="fw-bold fs-2 mb-3">ประวัติการเติบโตของ ORI</p>
      <ul class="nav justify-content-center nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
            type="button" role="tab" aria-controls="pills-home" aria-selected="true">กำไรสุทธิ</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
            type="button" role="tab" aria-controls="pills-profile" aria-selected="false">รายได้</button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"
          tabindex="0">
          <FinancialChart />
        </div>
        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
          <incomeChart />
        </div>
      </div>
    </div>

    <div class="container">
      <!-- Desktop only component -->
      <div class="desktop-only">
        <FinancialInforHome />
      </div>

      <!-- Mobile only component -->
      <div class="mobile-only">
        <FinancialInforHomeMobile />
      </div>
    </div>

    <div class="container mb-5">
      <p class="fw-bold text-title underline fs-2 mb-3">เอกสารล่าสุด</p>

      <div class="row text-start">
        <div class="col-md-5">
          <!-- <button class="btn btn-outline-primary custom-button-outlin mb-3"
            type="button">เอกสารเพื่อการลงทุนเพิ่มเติม</button> -->
          <div v-if="isLoading" class="spinner-grow custom-spinner d-flex justify-content-center align-items-center"
            role="status">
          </div>
        </div>
        <div class="col-md-7">
          <div class="card border border-0 mb-2" style="background-color: #FBFBFB;">
            <div class="card-body" v-if="FinancialData[0]">
              <div class="row">
                <div class="col-6 col-md-6 mb-md-0">
                  <i class="fa-regular fa-file-lines"></i> งบการเงินไตรมาสที่ {{ FinancialData[0].quarter }} ปี
                  {{ FinancialData[0].year }}
                </div>
                <div class="col-6 col-md-6 text-end">
                  <a :href="FinancialData[0].pdf_url" target="_blank" class="text-decoration-none">
                    <small class="text-muted"><i class="fa-solid fa-download"></i>
                      ดาวน์โหลด</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="card border border-0 mb-2" style="background-color: #FBFBFB;">
            <div class="card-body" v-if="Analysis[0]">
              <div class="row">
                <div class="col-6 col-md-9 mb-md-0">
                  <i class="fa-regular fa-file-lines"></i> คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ {{ Analysis[0].quarter }}
                  ปี
                  {{ Analysis[0].year }}
                </div>
                <div class="col-6 col-md-3 text-end">
                  <a :href="Analysis[0].pdf_url" target="_blank" class="text-decoration-none">
                    <small class="text-muted"><i class="fa-solid fa-download"></i>
                      ดาวน์โหลด</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="card border border-0 mb-2" style="background-color: #FBFBFB;">
            <div class="card-body" v-if="Meetings[0]">
              <div class="row">
                <div class="col-6 col-md-9 mb-md-0">
                  <i class="fa-regular fa-file-lines"></i> {{ Meetings[0].meeting_name }}
                </div>
                <div class="col-6 col-md-3 text-end">
                  <a :href="Meetings[0].meeting_url" target="_blank" class="text-decoration-none">
                    <small class="text-muted"><i class="fa-solid fa-download"></i>
                      ดาวน์โหลด</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="card border border-0 mb-2" style="background-color: #FBFBFB;">
            <!-- ตรวจสอบว่า latestOneReport มีข้อมูลหรือไม่ -->
            <div class="card-body" v-if="latestOneReport.length > 0">
              <div class="row">
                <div class="col-6 col-md-9 mb-md-0">
                  <i class="fa-regular fa-file-lines"></i> {{ latestOneReport[0].report_name }}
                </div>
                <div class="col-6 col-md-3 text-end">
                  <a :href="latestOneReport[0].report_pdf_url" target="_blank" class="text-decoration-none">
                    <small class="text-muted"><i class="fa-solid fa-download"></i>
                      ดาวน์โหลด</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <div class="container">
      <div class="row">
        <div class="col-md-6 mt-5">
          <p class="fw-bold text-title underline fs-2">ข่าวสื่อสิ่งพิมพ์</p>
          <div v-if="isLoading" class="spinner-grow custom-spinner d-flex justify-content-center align-items-center"
            role="status">
          </div>
          <p class="text-read text-end m-3 mb-5" style="cursor: pointer;" @click="goToNewSprintMedia">ดูทั้งหมด</p>

          <div v-for="(item, index) in NewsClippings.slice(0, 3)" :key="index"
            class="card border border-0 rounded-0 mb-3">
            <div class="row">
              <div class="col-md-3 d-flex justify-content-center align-items-center">
                <img :src="item.imageUrl || require('@/assets/logo-origin.png')" class="img-fluid"
                  alt="Image description">
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <p class="card-text">{{ item.title_news_clippings }}</p>
                  <p class="card-text text-read">
                    <a :href="item.url_news_clippings" target="_blank"><small>อ่านเพิ่มเติม</small></a>
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6 bg-col text-white">
          <p class="fw-bold text-title underline fs-2 mb-3 mt-5">ข่าวแจ้งตลาดหลักทรัพย์ฯ</p>
          <div v-if="isLoading" class="spinner-grow custom-spinner d-flex justify-content-center align-items-center"
            role="status">
          </div>
          <!-- {{ stockNews }} -->
          <div class="card card-calendar border border-0 rounded-0 mb-2 bg-col text-white"
            v-for="(item, index) in stockNews.slice(-4)" :key="index">
            <div class="row">
              <div class="col-md-auto">
                <div class="card-body">
                  <p class="card-text">{{ item.new_set_title }}</p>
                  <!-- <small>
                    <p >{{ item.new_set_date }}</p>
                  </small> -->
                  <p class="card-text text-read">
                    <a :href="item.new_set_pdf_url" target="_blank">
                      <small>อ่านเพิ่มเติม</small>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6" style="background-color: #FEF9F6;">
          <div class="card border border-0 rounded-0 mb-5 mt-5 justify-content-center m-3"
            style="background-color: #FEF9F6;height: 250px;">
            <p class="fw-bold text-title underline fs-2 mb-3">ติดต่อนักลงทุนสัมพันธ์</p>
            <p>โทรศัพท์ : 081-1311064</p>
            <p>โทรสาร : 02-3988066</p>
            <p>อีเมล : ir@origin.co.th</p>
          </div>
        </div>
        <!-- <div class="col-md-6 p-0">
          <div class="card border border-0 rounded-0  justify-content-center custom-card">
            <p class="fw-bold fs-2 mb-3">สมัครติดตามข่าวสาร</p>
            <p class="">ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็คทรอนิคส์ เราจะส่งข่าวสาร
              ให้ท่านทางอีเมลเมื่อมีข่าวสารทางบริษัทประกาศผ่านเว็บไซต์</p>

            <button class="btn btn-outline-primary custom-button-outlin" type="button">สมัครรับข่าวสาร</button>
          </div>
        </div> -->
        <div class="col-md-6 p-0">
          <div class="card border border-0 rounded-0 justify-content-center custom-card">
            <div class="text-box">
              <p class="fw-bold text-title underline fs-2 mb-5">สมัครติดตามข่าวสาร</p>
              <p>ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็คทรอนิคส์ เราจะส่งข่าวสาร
                ให้ท่านทางอีเมลเมื่อมีข่าวสารทางบริษัทประกาศผ่านเว็บไซต์</p>

              <button class="btn btn-outline-primary custom-button-outlin" type="button" @click="goToNews">สมัครรับข่าวสาร</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Highcharts from 'highcharts';
import FinancialChart from '../components/financialChart.vue';
import incomeChart from '../components/incomeChart.vue';
import FinancialInforHome from '../components/Home/FinancialInforHome.vue';
import FinancialInforHomeMobile from '../components/Home/FinancialInforHomeMobile.vue';

import store from "@/store";
import { mapState } from "vuex";
import { GET_SET_STOCK_QUOTATION_DATA, GET_FINANCIAL_DATA, GET_ANALYSIS_EXPLANATIONL_DATA, GET_MEETINGS_DATA, GET_ONE_REPORTS_DATA, GET_FNEWS_CLIPPINGS_DATA, GET_SET_STOCK_NEWS_DATA } from "../store/actions.type";
import dayjs from 'dayjs';

export default {
  name: 'HomePage',
  components: {
    FinancialChart,
    incomeChart,
    FinancialInforHome,
    FinancialInforHomeMobile
  },
  data() {
    return {
      isLoading: false,
      list: [],
      Percentagechange: "",
      change: "",
      FinancialData: "",
      Analysis: "",
      Meetings: "",
      OneReports: "",
      latestOneReport: "",
      NewsClippings: "",
      stockNews: ""

    };
  },
  async created() {
    this.isLoading = true;
    await this.init();
    this.isLoading = false;
  },
  methods: {
    async init() {
      const [
        stockQuotationData,
        financialData,
        analysisData,
        meetingsData,
        oneReportsData,
        newsClippingsData,
        stockNewsDeta
      ] = await Promise.all([
        store.dispatch(GET_SET_STOCK_QUOTATION_DATA),
        store.dispatch(GET_FINANCIAL_DATA),
        store.dispatch(GET_ANALYSIS_EXPLANATIONL_DATA),
        store.dispatch(GET_MEETINGS_DATA),
        store.dispatch(GET_ONE_REPORTS_DATA),
        store.dispatch(GET_FNEWS_CLIPPINGS_DATA),
        store.dispatch(GET_SET_STOCK_NEWS_DATA),
      ]);

      this.list = stockQuotationData;
      this.FinancialData = financialData;
      this.Analysis = analysisData;
      this.Meetings = meetingsData;
      this.OneReports = oneReportsData;
      this.NewsClippings = newsClippingsData;
      this.stockNews = stockNewsDeta;

      console.log(this.stockNews);


      if (this.OneReports && this.OneReports.length > 0) {
        this.latestOneReport = this.OneReports.slice(-1);
      } else {
        this.latestOneReport = [];
      }
    },
    formatDate(dateString) {
      return dayjs(dateString).format('DD MMMM YYYY, hh:mm:ss');
    },
    formatNewsDate(dateString) {
      return dayjs(dateString).format('DD MMMM YYYY');
    },
    calculateChange(last, prior) {
      const change = (last - prior).toFixed(2);
      return change;
    },
    calculatePercentageChange(last, prior) {
      if (prior === 0) return 0;
      const Percentagechange = ((last - prior) / prior) * 100;
      return Percentagechange.toFixed(2);
    },
    formatNumber(number) {
      return number.toLocaleString();
    },
    formatLastTwoDecimal(price) {
      return price ? price.toFixed(2) : "-";
    },
    changeClass(last, prior) {
      const change = last - prior;
      if (change > 0) {
        return 'text-success';
      } else if (change < 0) {
        return 'text-danger';
      }
      return '';
    },
    goToStockPriceInfo() {
      this.$router.push('/stockpriceinfo/info');
    },

    goToNewSprintMedia() {
      this.$router.push('/newinfo/newsprintmedia');
    },
    redirectToFactSheet() {
      window.open('https://www.set.or.th/th/market/product/stock/quote/ori/factsheet', '_blank');
    },
    goToNews() {
      this.$router.push('/informationinfo');
    },

  }
};
</script>

<style scoped>
.text-success {
  color: #0db23b !important;
  /* สีเขียวสำหรับค่าเพิ่มขึ้น */
}

.text-danger {
  color: #ff3c3c !important;
  /* สีแดงสำหรับค่าลดลง */
}

.custom-card {
  position: relative;
  background-image: url('../assets/bg-home-1.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 50px 30px;
  height: 100%;
  color: white;
  background-color: rgb(255 255 255 / 74%);
  background-blend-mode: overlay;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-box {
  z-index: 1;
  border-radius: 10px;
  color: black;
}

.custom-card .btn {
  z-index: 2;
}

.btn:hover {
  color: #585858;
}

.card-calendar {
  box-shadow: 0px 4px 20px 0px #00000014 !important;
  border-left: 5px solid #E87D2E !important;
  border-top: none !important;
  border-right: none !important;
  border-bottom: none !important;
  background-color: #414042;
}

.bg-col {
  background-color: #414042;
}

.custom-width {
  width: 450px;
}

.carousel-item {
  position: relative;
  height: 500px;
}

/* @media (max-width: 581px) {
  .carousel-item {
    height: 700px;
  }
}

@media (min-width: 582px) and (max-width: 768px) {
  .carousel-item {
    height: 900px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .carousel-item {
    height: 900px;
  }
} */

/* .carousel-item:nth-child(1) {
  background-image: url('../assets/banner-3.jpg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

@media (min-width: 430px) and (max-width: 1024px) {
  .carousel-item:nth-child(1) {
    background-image: url('../assets/banner-mobile-3.jpg'); 
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

@media (max-width: 430px) {
  .carousel-item:nth-child(1) {
    background-image: url('../assets/banner-mobile-3.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
} */

.carousel-item:nth-child(1) {
  background-image: url('../assets/banner.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

@media (min-width: 430px) and (max-width: 1024px) {
  .carousel-item:nth-child(1) {
    background-image: url('../assets/banner.png');  /* Add your iPad image */
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

@media (max-width: 430px) {
  .carousel-item:nth-child(1) {
    background-image: url('../assets/banner-mobile-1.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}




.carousel-item:nth-child(2) {
  background-image: url('../assets/banner-2.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

@media (min-width: 430px) and (max-width: 1024px) {
  .carousel-item:nth-child(2) {
    background-image: url('../assets/banner-2.png');  /* Add your iPad image */
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

@media (max-width: 430px) {
  .carousel-item:nth-child(2) {
    background-image: url('../assets/banner-mobile-2.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.carousel-caption {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.desktop-only {
  display: block;
  justify-self: center;
}

.mobile-only {
  display: none;
}

@media (max-width: 1400px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }
}

.text-read {
  color: #E87D2E;
}

.text-title.underline::after {
  content: "";
  display: block;
  height: 2px;
  background-color: #E87D2E;
  width: 10%;
  margin-top: 5px;
}
</style>

